import React from "react";
// import constants from "../../constants";
import Button from "../elements/forms/Button";
import { useNavigate } from "react-router-dom";

type Props = {
  title: string | undefined;
  image: any;
  message: string | undefined | null;
  btnText: string;
  link: string;
  onClose?: () => void;
};

const EmailVerifyModal: React.FC<Props> = ({
  title,
  image,
  message,
  btnText,
  link,
  onClose,
}) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    // Clear the state first
    onClose?.();
    // Then navigate
    navigate(link);
  };

  return (
    <div className="max-w-[630px] mx-auto max-h-[433px] px-3 py-3 rounded-[12px] text-center">
      <div className="mx-auto text-center">
        <img src={image} alt="email" className="mx-auto" />
      </div>
      <h3 className="md:text-[35px] text-[22px]">{title}</h3>
      <p className="md:text-[20px] text-[15px] font-[400] text-[#1E1E1E]">
        {message}
      </p>
      <Button
        title={btnText}
        onSubmitHandler={handleButtonClick}
        className="mx-auto mt-5"
      />
    </div>
  );
};

export default EmailVerifyModal;
